import React from 'react';
import { BackButton } from '../ui/BackButton';
import { ShopperFooter } from './ShopperFooter';
import { SHOPPER_HOME } from '../../constants/routes';

interface StaticPageLayoutProps {
  title: string;
  subtitle?: string;
  backFallback?: string;
  children: React.ReactNode;
  showFooter?: boolean;
}

export function StaticPageLayout({
  title,
  subtitle,
  backFallback = SHOPPER_HOME,
  children,
  showFooter = true,
}: StaticPageLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="sticky top-0 z-40 bg-white border-b border-gray-100">
        <div className="max-w-3xl mx-auto px-4 py-4">
          <div className="flex items-center">
            <BackButton fallback={backFallback} />
            <div className="ml-4 min-w-0">
              <h1 className="text-xl font-serif text-heading truncate">{title}</h1>
              {subtitle && <p className="text-sm text-body mt-0.5">{subtitle}</p>}
            </div>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-3xl mx-auto w-full px-4 py-6 pb-12 space-y-6">
        {children}
      </main>

      {showFooter && <ShopperFooter />}
    </div>
  );
}
